import { ReactNode } from "react";

import { clsx } from "clsx";

import styles from "./WarningBanner.module.scss";

export default function WarningBanner({ children, className }: { className?: string; children: ReactNode }) {
    const classes = [styles.scheduledJourneyCopy];
    if (className) {
        classes.push(className);
    }
    return (
        <span data-testid="warning-banner" className={clsx(classes)}>
            {children}
        </span>
    );
}
